import type { PropsWithChildren } from 'react';

import { FileListStyled } from './styles/FileListStyled'
import { type UploadCommonProps } from '../../Upload'

export interface IFileListProps {
  commonProps: UploadCommonProps
}

export const FileList = (props: PropsWithChildren<IFileListProps>) => {
  return <FileListStyled {...props} />
}
